import _ from 'lodash';
import * as ActionType from './actionType';
import { getLanguagesApi } from '../services/languages';
import enLang from '../locales/en/default.json';
import thLang from '../locales/th/default.json';

const switchLanguageAction = language => {
  return (dispatch, getState) => {
    if (getState().languages.currentActive !== language) {
      dispatch({
        type: ActionType.SWITCH_LANGUAGE,
        language
      });
    }
  };
};

const dispatchLanguages = dispatch => {
  getLanguagesApi().then(async items => {
    dispatch({
      type: ActionType.RECEIVE_LANGUAGES,
      data: _.compact(
        await Promise.all(
          _.map(items, async item => {
            const { code, name, enabled } = item;
            if (!enabled) return;
            let langData = {};
            if (code === 'th') {
              langData = thLang;
            } else if (code === 'en') {
              langData = enLang;
            }
            return {
              key: code,
              name: name,
              data: langData
            };
          })
        )
      )
    });
  });
};

export { switchLanguageAction, dispatchLanguages };



// WEBPACK FOOTER //
// ./src/actions/languages.js